// Thin fetch wrapper: same-origin, sends the session cookie, JSON in/out.

async function handle(res: Response) {
  if (res.status === 401) {
    // Session expired — bounce to login (preserve where we were).
    if (!location.pathname.startsWith('/login')) {
      location.href = '/login';
    }
    throw new Error('Unauthorized');
  }
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Request failed (${res.status})`);
  }
  const ct = res.headers.get('content-type') || '';
  return ct.includes('application/json') ? res.json() : res.text();
}

export function apiGet<T = any>(path: string): Promise<T> {
  return fetch(path, { credentials: 'include' }).then(handle);
}

export function apiSend<T = any>(
  path: string,
  method: 'POST' | 'PATCH' | 'DELETE',
  body?: unknown
): Promise<T> {
  return fetch(path, {
    method,
    credentials: 'include',
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  }).then(handle);
}
